import { render, staticRenderFns } from "./grand.vue?vue&type=template&id=69bd1f35&scoped=true&"
import script from "./grand.vue?vue&type=script&lang=js&"
export * from "./grand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bd1f35",
  null
  
)

export default component.exports